import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CtModelModule } from '@ctsolution/ct-framework';
import { WorkOrderPaymentsComponent } from './work-order-payments.component';
import { PaymentsEditModule } from '../../../../payments/payments-edit/payments-edit.module';

@NgModule({
  imports: [
    CommonModule,
    CtModelModule,
    // PaymentsEditModule è necessario per la dichiarazione di PaymentsEditComponent
    // aperto come dialog da PaymentsService.openForm() (CtA "Crea" della datatable).
    PaymentsEditModule
  ],
  declarations: [WorkOrderPaymentsComponent],
  exports: [WorkOrderPaymentsComponent]
})
export class WorkOrderPaymentsModule { }
